import { useEffect, useState } from "react";
import { completeAuth } from "./storage.js";

export default function AuthCallback({ onDone }) {
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        await completeAuth();
        // Clean URL and notify parent
        window.history.replaceState({}, "", "/");
        onDone?.();
      } catch (err) {
        setError(err.message);
      }
    })();
  }, [onDone]);

  return (
    <div style={{
      fontFamily: "'IBM Plex Sans',system-ui,sans-serif",
      background: "#080c14", minHeight: "100vh",
      display: "flex", alignItems: "center", justifyContent: "center",
      color: "#b8c4dc", padding: 24
    }}>
      <div style={{ textAlign: "center", maxWidth: 420 }}>
        {error ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 14 }}>⚠</div>
            <div style={{ fontSize: 18, fontWeight: 600, color: "#f87171", marginBottom: 8 }}>Authentication failed</div>
            <div style={{ fontSize: 14, color: "#6b7280", marginBottom: 20 }}>{error}</div>
            <a href="/" style={{ fontSize: 14, color: "#60a5fa", textDecoration: "none" }}>← Back to login</a>
          </>
        ) : (
          <>
            <div style={{ fontSize: 48, marginBottom: 14 }}>🔐</div>
            <div style={{ fontSize: 16, color: "#60a5fa", fontWeight: 600 }}>Signing you in…</div>
            <div style={{ fontSize: 13, color: "#1e3a5f", marginTop: 6 }}>Completing Dropbox authentication</div>
          </>
        )}
      </div>
    </div>
  );
}
